import { Box, Typography } from "@mui/material";
import React from "react";

const Introduction = () => {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 700,
          pb: 2,
          ml: { lg: "24px" }
        }}
      >
        Welcome to the Rajmarg Pravesh Portal!
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          pl: 0.5,
          ml: { lg: "24px" }
        }}
      >
        Portal for Access and Utility Permission Category including Industrial &
        Public Utilities (OFC, Pipelines, Wires etc.) Wayside Amenities & such
        other facilities along the National Highways.
      </Typography>
    </Box>
  );
};

export default Introduction;
